import type { knownParallelSearchMcpToolMetadataRegistrySchema } from "schemas/agentTools/generated/remote/parallel-search";
import type { OpencodeToolPart } from "schemas/generated/agentTools/opencode";
import type { OpencodeToolDisplay } from "../shared";

import { exhaustiveSwitch } from "replo-utils/lib/misc";

import {
  getQuotedArrayDetail,
  getToolDisplayText,
  getToolInputString,
  quotedDetail,
} from "../shared";

type KnownParallelSearchMcpToolName = Extract<
  keyof typeof knownParallelSearchMcpToolMetadataRegistrySchema.shape,
  string
>;

export function getParallelSearchMcpServerToolDisplay({
  toolName,
  toolPart,
}: {
  toolName: KnownParallelSearchMcpToolName;
  toolPart: OpencodeToolPart;
}) {
  return exhaustiveSwitch({ type: toolName })<OpencodeToolDisplay>({
    web_fetch: () => {
      const target =
        getQuotedArrayDetail({
          value: toolPart.state.input.urls,
        }) ??
        quotedDetail({
          value: getToolInputString({
            properties: ["objective"],
            toolPart,
          }),
        });
      return {
        summary: getToolDisplayText({
          completed: "Read webpages",
          pending: "Reading webpages",
          running: "Reading webpages",
          target,
        }),
        detail: null,
      };
    },
    web_search_preview: () => {
      const objective = getToolInputString({
        properties: ["objective"],
        toolPart,
      });
      return {
        summary: getToolDisplayText({
          completed: "Searched the web",
          pending: "Searching the web",
          running: "Searching the web",
          target: quotedDetail({ value: objective }),
        }),
        detail: null,
      };
    },
  });
}
